<template>
    <teleport to="head">
        <title>{{ HEAD_TITLE }} | Admisiones</title>
    </teleport>
    <UnauthNav />
    <div v-if="user.id">
        <MobileControls />
    </div>
    <IphoneBar />
    <div class="lcu-nonDash-wrap" :class="{ 'lcu-logged-dashWrap': user.id }">
        <SecondaryNav />
        <div class="lcu-page lcu-page-noSpacing">
            <HeroBanner :image="'/assets/heroes/LCU-Admissions-HD.jpg'">
                <section class="section">
                    <h3 class="lcu-hero-h3 lcu-center-text">
                        LEGACY CHRISTIAN UNIVERSITY
                    </h3>
                    <h1 class="lcu-hero-h1 lcu-center-text">
                        Sé parte de LCU
                    </h1>
                </section>
            </HeroBanner>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="col-grid-2">
                        <div>
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Todo comienza aquí
                                </h2>
                            </div>
                            <div class="row">
                            Legacy Christian University reafirma su compromiso con la formación
                            de líderes cristianos sólidos, maduros y guiados por el Espíritu Santo.
                            A través de este programa, declaramos que cada estudiante será equipado,
                            afirmado y enviado para cumplir su asignación divina.
                            </div>
                        </div>
                        <div class="lcu-frozen-container">
                            <img
                                class="lcu-frozen-img"
                                src="/assets/woman-study.jpg"
                                alt="student studying" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public">
                <div class="section-container">
                    <div class="col-grid-2">
                        <div>
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Una jornada única
                                </h2>
                            </div>
                            <div class="row">
                                Desde el primer día, te desarrollarás espiritual, personal y
                                profesionalmente a través de oportunidades de aprendizaje práctico
                                y una educación de primer nivel.
                            </div>
                            <div class="row">
                                <div class="lcu-buttons-grid">
                                    <button-cta
                                        :text="'Presencial'"
                                        border
                                        :type="'secondary'"
                                        :classes="['lcu-mobile-wideBtn']"
                                        @on-click="''" />
                                    <button-cta
                                        :text="'En Línea'"
                                        :type="'secondary'"
                                        :classes="['lcu-mobile-wideBtn']"
                                        @on-click="$router.push('/inscribirse')" />
                                </div>
                            </div>
                        </div>
                        <div />
                    </div>
                </div>
            </section>
            <section class="section-public-primary">
                <div class="section-container">
                    <div class="col-grid-2">
                        <div class="lcu-still-tile">
                            <img
                                src="/assets/manuel-papers.png"
                                class="lcu-still-img"
                                alt="brochure" />
                        </div>
                        <div class="lcu-center-tile">
                            <div class="row">
                                <h2 class="lcu-h2 lcu-h2-secondary">
                                    Manual Académico Oficial
                                </h2>
                            </div>
                            <div class="row">
                                Descarga totalmente gratis nuestro manual e infórmate
                                sobre los detalles del  programa para USA y Latinoamérica,
                                nuestro proceso de admisión, el apoyo estudiantil, formas
                                de pago y mucho más, todo en un solo lugar.
                            </div>
                            <div class="row">
                                <div class="lcu-buttons-grid">
                                    <button-cta
                                        :html="'<strong>Descargar Manual</strong><br/>USA'"
                                        :type="'secondary'"
                                        :classes="['lcu-mobile-wideBtn', 'lcu-span-weight']"
                                        @on-click="openManualLinkUSA" />
                                   <button-cta
                                        :text="'Solicitar Manual'"
                                        :html="'<strong>Descargar Manual</strong><br/>Latinoamérica'"
                                        :type="'secondary'"
                                        :classes="['lcu-mobile-wideBtn', 'lcu-span-weight']"
                                        @on-click="openManualLinkLatinoamerica" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public-gray">
                <div class="section-container">
                    <div class="col-2-thirds">
                        <div>
                            <div class="row">
                                <h2 class="lcu-h2">
                                    Contamos con opciones de pago
                                </h2>
                            </div>
                            <div class="row">
                                Queremos que tu educación sea accesible y flexible. Ofrecemos
                                diversas opciones de pago diseñadas para adaptarse a tus
                                necesidades, incluyendo pago completo, planes de pago mensuales
                                y asistencia para explorar oportunidades de ayuda financiera
                                cuando estén disponibles.
                            </div>
                        </div>
                        <div class="lcu-cc-container">
                            <img
                                class="lcu-cc-img"
                                src="/assets/cc.png"
                                alt="student studying" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="section-public">
                <div class="section-container">
                    <div class="row">
                        <h3 class="lcu-hero-h3 lcu-center-text">
                            LEGACY CHRISTIAN UNIVERSITY
                        </h3>
                    </div>
                    <div class="row">
                        <h1 class="lcu-section-h1 lcu-center-text">
                            ¡Tu futuro ministerial comienza aquí!
                        </h1>
                    </div>
                    <div class="row">
                        <div class="lcu-center-text">
                            <button-cta
                                :text="'Aplicar'"
                                @on-click="$router.push('/inscribirse')" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Footer from 'ç/footer/Footer.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import HeroBanner from '@/components/hero-banner/HeroBanner.vue';
import MobileControls from 'ç/nav/MobileControls.vue';
import IphoneBar from 'ç/nav/iphone-bar/IphoneBar.vue';
import UnauthNav from 'ç/nav/UnauthNav.vue';
import SecondaryNav from 'ç/nav/SecondaryNav.vue';

export default {
  name: 'about-page',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    UnauthNav,
    SecondaryNav,
    ButtonCta,
    Footer,
    MobileControls,
    IphoneBar,
    HeroBanner,
  },
  methods: {
    openManualLinkUSA() {
      window.open(
        'https://lcu-web-uploads.s3.us-west-2.amazonaws.com/public-assets/LCU-Manual-USA.pdf',
        '_blank',
        'noopener,noreferrer',
      );
    },
    openManualLinkLatinoamerica() {
      window.open(
        'https://lcu-web-uploads.s3.us-west-2.amazonaws.com/public-assets/LCU-Manual-de-LATAM.pdf',
        '_blank',
        'noopener,noreferrer',
      );
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-frozen-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}

.lcu-cc-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: $tablet-max) {
    justify-content: flex-start;
  }
}

.lcu-still-img {
  width: 300px;
}

.lcu-still-tile {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lcu-center-tile {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.lcu-frozen-img {
  position: absolute;
  top: 25%;
  width: 80%;

  @media only screen and (max-width: $tablet-max) {
    width: 100%;
  }

  @media only screen and (max-width: $mobile-max) {
    position: relative;
    top: auto;
    width: 100%;
  }
}

.lcu-buttons-grid {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    grid-gap: 20px;
}

.lcu-cc-img {
    width: 300px;;
}
</style>
